import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteFirmware } from "./deleteFirmwareSlice";
import { deleteIotAgent } from "./deleteIotAgentSlice";
import useNotification from "../../../components/notification/useNotification";
import { isSuccessResponse } from "../../../common/utils";
import {
  selector as listFirmwareApi,
  fetchFirmwareData,
} from "../firmwareSlice";
import { selector as listIotAgentApi, fetchIotData } from "../iotAgentSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { IColumns, IListFirmwares } from "../../../common/types/firmwareTypes";
import { IListIotAgent } from "../../../common/types/iotAgentTypes";
import { Action } from "redux";
import { useSpinner } from "../../../customHooks";
import { actions as spinnerActions } from "../../../components/ui/spinner/spinnerSlice";
import { Status } from "../../../common/constants";

export const useDeleteDeviceExecutables = (name, version, isFirmware) => {
  const dispatch: any = useDispatch();
  const dispatchFirmwares: ThunkDispatch<IListFirmwares, undefined, Action> =
    useDispatch();
  const dispatchIotAgents: ThunkDispatch<IListIotAgent, undefined, Action> =
    useDispatch();
  const [showModel, setShowModel] = useState<boolean>(false);
  const listIotAgentsResponse: IListIotAgent = useSelector(listIotAgentApi);
  const listFirmwaresResponse: IListFirmwares = useSelector(listFirmwareApi);

  const status: string =
    listFirmwaresResponse.status === Status.PENDING
      ? listFirmwaresResponse.status
      : listIotAgentsResponse.status === Status.PENDING
      ? listIotAgentsResponse.status
      : listFirmwaresResponse.status;
  useSpinner(status);

  const handleClose = useCallback(() => {
    setShowModel(false);
  }, []);

  const handleShow = useCallback(() => {
    setShowModel(true);
  }, []);

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const handleDeleteButtonClick = () => {
    handleClose();
    const deleteFile = isFirmware ? deleteFirmware : deleteIotAgent;
    try {
      dispatch(spinnerActions.setApiStatus(Status.PENDING));
      dispatch(deleteFile({ name, version })).then((response) => {
        if (isSuccessResponse(response.payload)) {
          dispatchFirmwares(fetchFirmwareData());
          dispatchIotAgents(fetchIotData());
          dispatch(spinnerActions.setApiStatus(Status.SUCCESS));
          showSuccessNotification(response.payload.message);
        } else {
          showWarningNotification(response.error.message);
        }
      });
    } catch (error) {
      dispatch(spinnerActions.setApiStatus(Status.FAILED));
      console.error("Error deleting Firmware:", error);
    }
  };

  return {
    handleDeleteButtonClick,
    showModel,
    handleShow,
    handleClose,
  };
};
